import { Component } from '@opten/compiler/metadata/component';
import { debounce } from '@opten/reactive/debounce';
import { ScrollMagicController, ScrollMagicModalController } from '../main';

declare const ScrollMagic: any;
declare const TweenMax: any;
declare const Linear: any;
@Component({ className: 'js-transform-full-to-half' })
export class TransformFullToHalfComponent {
	private scene: any;
	private inner: HTMLElement;

	constructor(private element: HTMLElement) {
		this.inner = this.element.querySelector(
			'.js-transform-full-to-half-inner'
		);

		this.handleScene();
		window.addEventListener(
			'resize',
			debounce(() => {
				this.handleScene();
			}, 100)
		);
	}

	private handleScene() {
		if (window.innerWidth >= 768) {
			if (!this.scene) {
				this.scene = new ScrollMagic.Scene({
					triggerElement: this.element,
					triggerHook: 'onEnter',
					offset: window.innerHeight * -0.2, //offset
					duration: () => {
						return this.element.clientHeight;
					}
				})
					.setTween(
						TweenMax.from(this.inner, 1, {
							width: '100vw',
							height: '100vh',
							left:
								this.element.getBoundingClientRect().left +
									30 >=
								window.innerWidth / 2
									? '-50vw'
									: '0',
							top: '-120vh', //offset
							ease: Linear.easeNone
						})
					)
					// .addIndicators()
					.addTo(
						this.element.closest('.js-modal')
							? ScrollMagicModalController
							: ScrollMagicController
					);
			}
			this.scene.update(true);
		} else {
			if (this.scene) {
				TweenMax.set(this.element, { clearProps: "all" });
				this.scene.removeTween(true);
				this.scene.destroy(true);
			}
			this.scene = undefined;
		}
	}
}
